const SUPABASE_URL = 'https://wetxjqppusuquqtzhvfv.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_Ik75DR_2FH08mUiUzo6dKw_mvr6mdPt';
const SUPABASE_ANON_KEY_OLD = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndldHhqcXBwdXN1cXVxdHpodmZ2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU0MTUzMzAsImV4cCI6MjA3MDk5MTMzMH0.oqDQ9-VO_0MbfhVeAWZFwvL1go-oHoeXmCKgndeg6ac'

const SERVER_API_URL =
  import.meta.env.VITE_SERVER_API_URL ?? 'http://localhost:3000';

export { SUPABASE_URL, SUPABASE_ANON_KEY, SERVER_API_URL, SUPABASE_ANON_KEY_OLD };